import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate, setLocale } from 'react-redux-i18n'
import { changeTypeFontSize } from '../../../../app/slice'
import { store } from '../../../../app/store'
import { putLanguage } from '../../../common/category/store/thunk'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import { Element } from '../../../common/html/element'
import { Radio } from '../../../common/html/radio'
import { Panel } from '../../../common/panel'
import {
  FORMAT,
  changeLocaleDateTime,
  formatDateTime,
  getCurrentDateTime,
} from '../../../helpers/datetime'
import { saveLanguage } from '../../../helpers/language'
import classes from '../../index.module.scss'
import {
  selectSettings,
  setCurrency,
  setEmailLanguage,
  setLanguage,
  setTypeFontSize,
} from '../store/slice'
import { putUserSettingAlternative } from '../store/thunk'
import { LIST_CURRENCY, LIST_FONT_SIZES, LIST_LANGUAGE } from './constants'

const appendStyleRadioItem = { marginRight: 40, width: 90 }

export const Settings = () => {
  const dispatch = useDispatch()
  const timeZone = UseTimeZone()

  const defaultLanguage = useSelector((state) => state.i18n.locale)
  const settings = useSelector(selectSettings)

  const params = {
    languageCode: settings?.lang,
    languageCodeEmail: settings?.emailLang,
    currencyCode: settings?.currency,
  }

  const dateFormat = formatDateTime(
    getCurrentDateTime(undefined, defaultLanguage, timeZone),
    FORMAT.DATE,
    defaultLanguage,
    timeZone,
  )

  const handleChangeLanguage = (languageCode) => {
    store.dispatch(setLocale(languageCode))
    saveLanguage(languageCode)
    changeLocaleDateTime(languageCode)
    dispatch(putLanguage({ languageCode }))
  }

  const handleChangeEmailLanguage = (languageCodeEmail) => {
    dispatch(setEmailLanguage(languageCodeEmail))
    dispatch(
      putUserSettingAlternative({
        userSetting: { ...params, languageCodeEmail },
      }),
    )
  }

  const handleChangeCurrency = (currencyCode) => {
    dispatch(setCurrency(currencyCode))
    dispatch(
      putUserSettingAlternative({
        userSetting: { ...params, currencyCode },
      }),
    )
  }

  const handleChangeFontSize = (fontSize) => {
    dispatch(setTypeFontSize(fontSize))
    dispatch(changeTypeFontSize(fontSize))
  }

  useEffect(() => {
    dispatch(setLanguage(defaultLanguage))
  }, [defaultLanguage])

  return (
    <Panel label="settingPreferences.SETTINGS" isI18n style={{ marginTop: 0 }}>
      <div className="flexRow flex1">
        <div className={classes.settingsContent}>
          <div className={classes.radioListContainer}>
            <Element className={classes.radioSettingContent}>
              <Translate value="settingPreferences.LANGUAGE_PLATFORM" />
            </Element>
            <div className={classes.radioList}>
              {LIST_LANGUAGE.map((item) => (
                <Radio
                  key={item.title}
                  title={item.title}
                  isI18n
                  value={item.value}
                  appendStyle={appendStyleRadioItem}
                  activeValue={settings.lang}
                  isCheckOnClickText
                  onChange={handleChangeLanguage}
                />
              ))}
            </div>
          </div>

          <div className={classes.radioListContainer}>
            <Element className={classes.radioSettingContent}>
              <Translate value="settingPreferences.LANGUAGE_EMAIL" />
            </Element>
            <div className={classes.radioList}>
              {LIST_LANGUAGE.map((item) => (
                <Radio
                  key={item.title}
                  title={item.title}
                  isI18n
                  value={item.value}
                  appendStyle={appendStyleRadioItem}
                  activeValue={settings.emailLang}
                  isCheckOnClickText
                  onChange={handleChangeEmailLanguage}
                />
              ))}
            </div>
          </div>

          <div className={classes.radioListContainer}>
            <Element className={classes.radioSettingContent}>
              <Translate value="settingPreferences.TIMEZONE" />
            </Element>
            <div className={classes.radioList}>{`GMT ${timeZone}`}</div>
          </div>

          <div className={classes.radioListContainer}>
            <Element className={classes.radioSettingContent}>
              <Translate value="settingPreferences.CURRENCY" />
            </Element>
            <div className={classes.radioList}>
              {LIST_CURRENCY.map((item) => (
                <Radio
                  key={item.title}
                  title={item.title}
                  isI18n
                  value={item.value}
                  appendStyle={appendStyleRadioItem}
                  activeValue={settings.currency}
                  isCheckOnClickText
                  onChange={handleChangeCurrency}
                />
              ))}
            </div>
          </div>

          <div className={classes.radioListContainer}>
            <Element className={classes.radioSettingContent}>
              <Translate value="settingPreferences.FONT_SIZE" />
            </Element>
            <div className={classes.radioList}>
              {LIST_FONT_SIZES.map((item) => (
                <Radio
                  key={item.title}
                  title={item.title}
                  isI18n
                  value={item.value}
                  appendStyle={appendStyleRadioItem}
                  activeValue={settings.typeFontSize}
                  isCheckOnClickText
                  onChange={handleChangeFontSize}
                />
              ))}
            </div>
          </div>
        </div>
        <div className={classes.settingsContent}>
          <div className={classes.radioListContainer}>
            <Element
              className={classes.verticalLine}
              style={{ backgroundColor: '#9C9C9C' }}
            />
            <Element className="fw600">
              <Translate value="settingPreferences.DATE_FORMAT" />
            </Element>
            <div className={classes.radioList}>{dateFormat}</div>
          </div>
        </div>
      </div>
    </Panel>
  )
}
